module.exports = __webpack_public_path__ + "img/explore_05.2e410de4.jpg";